
  (function () {
    const wrapper = document.querySelector('.slider-wrapper');
    const nextBtn = document.querySelector('.next-btn');
    const prevBtn = document.querySelector('.prev-btn');
    const cards = document.querySelectorAll('.review-card');

    if (!wrapper || !nextBtn || !prevBtn || cards.length === 0) return;

    let currentIndex = 0;
    let cardsPerPage = window.innerWidth <= 768 ? 2 : 2;
    let totalPages = Math.ceil(cards.length / cardsPerPage);

    function recalculatePages() {
      const prevCardsPerPage = cardsPerPage;
      cardsPerPage = window.innerWidth <= 768 ? 2 : 2;
      totalPages = Math.ceil(cards.length / cardsPerPage);
      // Adjust currentIndex if out of bounds
      if (currentIndex > totalPages - 1) {
        currentIndex = totalPages - 1;
      }
    }

    // Add cursor styles
    wrapper.style.cursor = 'grab';
    wrapper.style.userSelect = 'none';
    wrapper.style.touchAction = 'pan-y pinch-zoom';

    // Swipe variables
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startScrollLeft = 0;

      function updateSlider() {
    recalculatePages();
    const cardWidth = cards[0].offsetWidth;
    const gap = 20; // gap between cards
    const moveBy = Math.floor(cardsPerPage / 2) * (cardWidth + gap); // move by 2 cards width (1 row)

    const offset = currentIndex * moveBy;
    wrapper.scrollTo({ left: offset, behavior: 'smooth' });

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === totalPages - 1;
  }

  function moveToNext() {
    if (currentIndex < totalPages - 1) {
      currentIndex++;
      updateSlider();
    }
  }

  function moveToPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  }

    // Mouse events for desktop
    let mouseDownX = 0;
    wrapper.addEventListener('mousedown', (e) => {
      isDragging = true;
      mouseDownX = startX = e.pageX - wrapper.offsetLeft;
      startScrollLeft = wrapper.scrollLeft;
      wrapper.style.cursor = 'grabbing';
      wrapper.style.scrollBehavior = 'auto';
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      // No scroll movement, just visual feedback
    });

    wrapper.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      wrapper.style.cursor = 'grab';
      wrapper.style.scrollBehavior = 'smooth';
      const endX = e.pageX - wrapper.offsetLeft;
      const diff = endX - mouseDownX;
      const threshold = 50; // Minimum px to consider as swipe
      if (diff < -threshold) {
        moveToNext();
      } else if (diff > threshold) {
        moveToPrev();
      } else {
        updateSlider(); // Snap back if not enough swipe
      }
    });

    wrapper.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        wrapper.style.cursor = 'grab';
        wrapper.style.scrollBehavior = 'smooth';
        updateSlider();
      }
    });

    // Touch events for mobile
    let touchStartX = 0;
    wrapper.addEventListener('touchstart', (e) => {
      isDragging = true;
      touchStartX = e.touches[0].pageX - wrapper.offsetLeft;
      startScrollLeft = wrapper.scrollLeft;
      wrapper.style.scrollBehavior = 'auto';
    });

    wrapper.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      // No scroll movement, just visual feedback
    });

    wrapper.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      wrapper.style.scrollBehavior = 'smooth';
      const endX = (e.changedTouches && e.changedTouches[0].pageX - wrapper.offsetLeft) || 0;
      const diff = endX - touchStartX;
      const threshold = 50; // Minimum px to consider as swipe
      if (diff < -threshold) {
        moveToNext();
      } else if (diff > threshold) {
        moveToPrev();
      } else {
        updateSlider(); // Snap back if not enough swipe
      }
    });

      // Button click events
  nextBtn.addEventListener('click', moveToNext);
  prevBtn.addEventListener('click', moveToPrev);

    // Prevent default drag behavior
    wrapper.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    window.addEventListener('resize', updateSlider);

    updateSlider();
  })();